import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Grid,
  useMediaQuery,
  Tabs,
  Tab,
} from "@mui/material";
import { useSelector } from "react-redux";
import AddSection from "../../Components/Partials/AddSection/AddSection";
import { theme } from "../../Theme";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DroppableAddSection from "../../DragAndDrop/DroppableAddSection";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { SortableDragOverlay } from "../../DragAndDrop/SortableDragOverlay";
import { SortableChart } from "../StatisticsTest/components/SortableChart";
import { DropDownDashboard } from "./DropDownDashboard";
import { onDragEndHandler } from "../../DragAndDrop/SortableHandlers";
import { useCustomSensors } from "../../DragAndDrop/DragHandlers";
import { data } from "./data";
import { getUrl } from "src/Utils/Common";
import { PinnedKpis } from "../StatisticsTest/components/PinnedKpis";
import ResetFiltersButton from "src/Components/shared/shared/ResetFiltersButton";
function Dashboard() {
  const isMobile = useMediaQuery("(max-width:600px)"); // Responsive check

  const currentChartType = useSelector((state) => state.chart.currentChartType);
  const currentDateComparison = useSelector(
    (state) => state.dateCompare.currentDateComparison
  );
  const projectId = useSelector((state) => state.userProject.projectId);
  const [menuConfig, setMenuConfig] = useState({});
  const [users, setUsers] = useState(data);
  const [activeId, setActiveId] = useState(null);
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  const sensors = useCustomSensors();
  const [quarters, setQuarters] = useState([]);
  const [monthsOption, setMonthsOption] = useState([]);
  const [showYears, setShowYears] = useState(false);
  const [sectionInView, setSectionInView] = useState(false);
  const [activeSection, setActiveSection] = useState("section1");
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  useEffect(() => {
    const handler = (e) => setTabIndex(e.detail);
    window.addEventListener("tour:openTab", handler);
    return () => window.removeEventListener("tour:openTab", handler);
  }, []);

  const section2Ref = useRef(null);
  const section1Ref = useRef(null);


  function RemoveComponent(id) {
    let itemToMove;
    setUsers((prevUsers) => {
      itemToMove = prevUsers.find((item) => item.id === id);
      const updatedMainDash = prevUsers.filter((item) => item.id !== id);
      setItems((prevItems) => {
        const updatedAddSection = [...prevItems.addSection, itemToMove];
        return { ...prevItems, addSection: updatedAddSection };
      });
      return updatedMainDash;
    });
  }

  const onDragStartHandler = (event) => setActiveId(event.active.id);
  const onDragCancelHandler = () => setActiveId(null);

  const [items, setItems] = useState({
    addSection: [
      // {
      //   id: "SalesColumnChart",
      //   component: <SalesColumnChart />,
      //   name: "Sales",
      //   title: "Sales",
      //   xs: 12,
      //   md: 4,
      // },
    ],
  });

  useEffect(() => {
    // generate a random num between 1 and 100
    const x = Math.floor(Math.random() * 100);
    const y = Math.floor(Math.random() * 100);

    console.log(`Current date comparison: ${currentDateComparison}`);
    // Update the chart rendering based on the current date comparison
    // This could involve updating state or re-rendering the component

    // Update the users data with new values
    // Update the `dataValues` dynamically by modifying the `data` field
    setUsers((prevUsers) =>
      prevUsers.map((user) => ({
        ...user,
        component: React.cloneElement(user.component, {
          dataValues: user.component.props.dataValues?.map(
            (item) => {
              return { ...item, data: [x, y] };
            }
            // item.name === "Price IYA"
            // ?
            // Update the `data` field for matching items
            // : item
          ),
        }),
      }))
    );
  }, [currentDateComparison]);

  // Fetch options for years, quarters, and months using projectId
  useEffect(() => {
    function fetchHierarchyData() {
      if (!projectId) {
        console.warn("Project ID is not set in Redux state.");
        return;
      }

      fetch(`${getUrl()}/market_overview/hierarchy`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("userId") || "",
            "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
          },
          body: JSON.stringify({ project_id: projectId }),
        })
        .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        const hierarchyData = result["0"]; // Extract the hierarchy response from API

        // Format menuConfig dynamically from API response
        const dynamicMenuConfig = {};
        Object.entries(hierarchyData).forEach(([key, values]) => {
          if (
            key !== "price_bracket" &&
            key !== "size" &&
            key !== "size_bracket" &&
            key !== "sku_db" && key !== "sku_id"
          ) {
            dynamicMenuConfig[key] = values;
          }
        });

        dynamicMenuConfig["channel"] = [];
        dynamicMenuConfig["retailer"] = [];
        setMenuConfig(dynamicMenuConfig); // Update state with API response
      }) 
      .catch ((error) => {
        console.error("Error fetching hierarchy data:", error);
      });
    }

    function fetchOptions() {
      if (!projectId) {
        console.warn("Project ID is not set in Redux state.");
        return;
      }

      fetch(`${getUrl()}/market_overview/year_quart_mon?project_id=${projectId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": localStorage.getItem("userId") || "",
              "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
            },
          }
        )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.data;
        })
        .then((result) => {
          setShowYears(result.year_option || false);

          const validQuarters = Object.entries(result)
            .filter(([key, value]) => key.startsWith("Q") && value === true)
            .map(([key]) => key);
          setQuarters(validQuarters);

          setMonthsOption(result.months_option || []);
        })
        .catch ((error) => {
        console.error("Error fetching options:", error);
      });
    }

    fetchHierarchyData();
    fetchOptions();
  }, [projectId]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.target.id === "section2") {
          setSectionInView(entry.isIntersecting); // Detect when Section 2 is in view
        }
      },
      { threshold: 0.5 } // Trigger when at least 50% of Section 2 is in view
    );

    if (section2Ref.current) {
      observer.observe(section2Ref.current);
    }

    return () => {
      if (section2Ref.current) {
        observer.unobserve(section2Ref.current);
      }
    };
  }, []);

  // Map months to readable names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const formattedMonths = monthsOption.map((month) => monthNames[month - 1]);

  // const menuConfig = {
  //   brand: ["AFIA", "AL ARABI", "LITE LIFE"],
  //   segment: ["CANOLA OIL", "SUNFLOWER OIL"],
  // };

  const onDragEnd = (event) => {
    onDragEndHandler(event, setUsers, users);
    setActiveId(null);
  };

  const toggleAddSection = () => setIsAddSectionOpen((prev) => !prev);

  const TitleStyle = {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.fontSize.medium,
    paddingY: 1,
    color: theme.palette.primary.main,
  };

  const ComponentBar = {
    backgroundColor: theme.palette.secondary.main,
    marginTop: "10px",
    padding: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative",
  };
  const CloseButton = {
    alignSelf: "flex-end",
    padding: 0,
    margin: 0,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    cursor: "pointer",
  };
  return (
    <Box sx={{ display: "flex", height: "84.5vh",
      width: { xs: "calc(100% - 30px)", sm: "calc(100% - 50px)" },
     }}>
      {/* Main content area */}
      <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>
        {tabIndex === 0 && (
          <div data-tour="market-kpis">
            {/* Market KPIs content */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                margin: "15px",
              }}
            >
              <hr
                style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
              />
              <span style={{ padding: "0 10px", color: "#999" }}>
                {" "}
                Market KPIs
              </span>
              <hr
                style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
              />
            </div>
            <PinnedKpis />
          </div>
        )}
        {tabIndex === 1 && (
          <>
            {/* Workbook/Market Brands Overview content */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                margin: "15px",
              }}
            >
              <hr
                style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
              />
              <span style={{ padding: "0 10px", color: "#999" }}>Workbook</span>
              <hr
                style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
              />
            </div>
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={onDragEnd}
              sensors={sensors}
              onDragStart={onDragStartHandler}
              onDragCancel={onDragCancelHandler}
            >
              <SortableContext items={users.map((u) => u.id)} strategy={rectSortingStrategy}>
                 
                <Box
                  data-tour="workbook-toolbar"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: "100%",
                    mt: 1,
                    mb: 2,
                    gap: 2,
                  }}
                >
                  <ResetFiltersButton />
                  {/* <DropDownDashboard
                    menuConfig={menuConfig}
                    local={false}
                    variant="global"
                  /> */}
                  <AddSection toggleOpen={toggleAddSection} />
                </Box>
                {isAddSectionOpen && (
                  <Box
                    component={Paper}
                    sx={{
                      backgroundColor: "#f5f5f5",
                      padding: 2,
                      marginBottom: 2,
                    }}
                  >
                    <CloseOutlinedIcon
                      sx={{ alignSelf: "flex-end", cursor: "pointer" }}
                      onClick={toggleAddSection}
                    />
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      <DroppableAddSection
                        id="addSection"
                        children={items.addSection}
                        items={items.addSection}
                        setUsers={setUsers}
                        setItems={setItems}
                      />
                    </Box>
                  </Box>
                )}
                <Grid container spacing={2}>
                  {users.map((user) => (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={user.md}
                      key={user.id}
                      sx={{ width: "100%" }}
                    >
                      <SortableChart
                        user={user}
                        RemoveComponent={() => RemoveComponent(user.id)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </SortableContext>
              <SortableDragOverlay activeId={activeId} items={users} />
            </DndContext>
          </>
        )}
      </Box>
      {/* Vertical Tabs on the right */}
      <Tabs
        data-tour="workbook-tabs"
        orientation="vertical"
        value={tabIndex}
        onChange={handleTabChange}
        sx={{
          borderLeft: 1,
          borderColor: "divider",
          minWidth: { xs: 30, sm: 50 },
          height: "85vh",
          margin: 0,
          alignSelf: "stretch",
          position: "fixed",
          right: 0,
          top: "65px",
          zIndex: 1400,
          pt: { xs: 3, sm: 1 },
          "& .MuiTabs-flexContainer": {
            alignItems: "flex-start", // Align tabs to the top
          },
        }}
        variant="scrollable"
      >
        <Tab
          sx={{
            textTransform: "none",
            minWidth: { xs: 30, sm: 50 },
            maxWidth: { xs: 30, sm: 50 },
            minHeight: 120,
            maxHeight: 120,
            marginBottom: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&.Mui-selected": {
              color: "#ffffff",
              fontWeight: "bold",
              backgroundColor: "#00265E",
              borderRight: "4px solid",
              borderRadius: "10px 0 0 10px",
            },
          }}
          label={
            <span
              style={{
                display: "inline-block",
                transform: "rotate(-90deg)",
                whiteSpace: "nowrap",
                fontSize: window.innerWidth < 600 ? 12 : window.innerWidth < 900 ? 14 : 16,
                fontWeight: 500,
              }}
            >
              Market KPIs
            </span>
          }
        />
        <Tab
          sx={{
            textTransform: "none",
            minWidth: { xs: 30, sm: 50 },
            maxWidth: { xs: 30, sm: 50 },
            minHeight: 120,
            maxHeight: 120,
            marginBottom: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&.Mui-selected": {
              color: "#ffffff",
              fontWeight: "bold",
              backgroundColor: "#00265E",
              borderRight: "4px solid",
              borderRadius: "10px 0 0 10px",
            },
          }}
          label={
            <span
              style={{
                display: "inline-block",
                transform: "rotate(-90deg)",
                whiteSpace: "nowrap",
                fontSize: window.innerWidth < 600 ? 12 : window.innerWidth < 900 ? 14 : 16,
                fontWeight: 500,
              }}
            >
              Workbook
            </span>
          }
        />
      </Tabs>
    </Box>
  );
}

export default Dashboard;

// const menuConfig = {
//   years: showYears ? ["2022", "2023", "2024"] : null,
//   months: formattedMonths.length > 0 ? formattedMonths : null,
//   quarters: quarters.length > 0 ? quarters : null,
// };
